import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { useIpWhitelist } from "@/hooks/useIpWhitelist";
import { SessionTimeoutProvider } from "@/components/session/SessionTimeoutProvider";
import { MfaGate } from "@/components/security/MfaGate";

import { Loader2 } from "lucide-react";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
}

export function ProtectedRoute({ children, requireAdmin = false }: ProtectedRouteProps) {
  const { user, isLoading, isAdmin } = useAuth();
  const { isChecking, isBlocked } = useIpWhitelist();
  const location = useLocation();

  if (isLoading || isChecking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="flex flex-col items-center gap-4">
          <Loader2 className="w-8 h-8 animate-spin text-accent" />
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user || isBlocked) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requireAdmin && !isAdmin) {
    return <Navigate to="/app" replace />;
  }

  return (
    <SessionTimeoutProvider>
      <MfaGate>{children}</MfaGate>
    </SessionTimeoutProvider>
  );

}
